import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { AppHelper } from "../appHelper";
import { Config } from "../core/config/config";
import { General } from "../../siteManagement/general";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import React from "react";
export default class EditTicketMachines extends React.Component<any, any>{
    common = new AppHelper();
    private _gridOptions: {} = null;
    private _translations: [];
    private _gridData: MachineViewModel[];
    private _problemNr = null;
    private _copyFromProject = "copyFromProject";
    private _createNew = "createNewMaschine";
    private _TIDShppingCart = "_TIDShppingCart";
    private _sheet: Sheet;
    private _TIDActive: boolean = false;

    

    constructor(props) {
        super(props);
        this._gridData = [];
    }

    private _loadGridData = () => {
        let url = "Procedure/GetMachines?problemNr=" + this._problemNr;
        HTTPService.get<JsonResultClass<MachineViewModel[]>>(url)
            .then(result => {
                this._gridData = result.Data;
                this.setState({});
            });
    }

    private _addMachines = async (data: { maschnr }[]) => {
        const lst = data.map(item => item.maschnr);

        const result = await HTTPService.post<JsonResultClass>("Procedure/AddMachines", { problemNr: this._problemNr, machineNrs: lst });
        if (result.Code == 0) {
            this._loadGridData()
            this._sheet.trigger(SheetEventType.Custom, { event: "Reloading" });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private _loadMachineSearch = (dataSource: DataSource) => {
        let id = 0;
        if (dataSource == DataSource.project)
            id = 1;
        
        let url = Config.baseUrl + "DynamicSearch/Window/ticketMachines?multi=true&cus_TicketId=" + this._problemNr
            + "&adrnr=" + this.props.entity.Adresse_Key
            + "&status=0"
            + "&cus_DataSource=" + id + "&displayPattern=[[maschnr]]";

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true, preventUrlChangeOnNew: true });
        sheet.setTitle(this._translations["WebSMS.Title.MachineSearch"]);
        sheet.bind(SheetEventType.ItemsSelected, (data) => {
            this._addMachines(data.data);
        });
    }    

    private __TIDopenShppingCart = (maschNr: string) => {
        const url = "TidInnosoft/getTIDShoppingCartUrl";
        HTTPService.post<JsonResultClass>(url, {problemNr: this._problemNr, maschNr: maschNr }).then(result => {
                    if (result.Code == 0 && Helper.hasValue(result.Data)) {
                        Helper.openInNewBrowserTab(result.Data);                       
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
    }

    private _removeMachine = (maschNr) => {
        DialogHelper.confirm(this.props.context.translations["WebSMS.Ticket.RemoveMachine"]).then(isOk => {
            if (isOk) {
                let url = "Procedure/DeleteMachine";
                HTTPService.post<JsonResultClass>(url, { problemNr: this._problemNr, maschNr: maschNr }).then(result => {
                    if (result.Code == 0) {
                        this._loadGridData();
                        this._sheet.trigger(SheetEventType.Custom, { event: "Reloading" });
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _createGrid = () => {
        const fullLoaded: boolean = Helper.hasValue(this._gridOptions) && Helper.hasValue(this._translations);
        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [
                { type: ToolBarStandardButtonType.NEW, caption: this._translations["Standard.Add"], enabled: this.props.entity.RecordRight.CanWrite },
                { type: ToolBarStandardButtonType.DELETE, caption: this._translations["Standard.Entfernen"], enabled: this.props.entity.RecordRight.CanWrite }
            ];
            const customButtons: Array<GridCustomToolBarButton> = [];
            const { CanCreateNewMachine } = this.props.entity.RecordRight;
            if (CanCreateNewMachine)
                customButtons.push({ caption: Helper.getTranslation("Standard.Neu"), id: this._createNew, iconClass: "fa-solid fa-plus", enabled: this.props.entity.RecordRight.CanWrite, autoEnabledOnRecordSelected: false });
            customButtons.push({ caption: this._translations["WebSMS.Ticket.CopyMachinesFromProject"], id: this._copyFromProject, iconClass: "k-i-seek-s", enabled: this.props.entity.RecordRight.CanWrite && Helper.hasValue(this.props.entity.Projekt_Key), autoEnabledOnRecordSelected: false });

            if (this._TIDActive && !Config.settings.isMobileApp)
                customButtons.push({ caption: this._translations["WebSMS.Ticket.TIDOpenShoppingCart"], id: this._TIDShppingCart, iconClass: "k-i-cart", enabled: this.props.entity.RecordRight.CanWrite, autoEnabledOnRecordSelected: true });

            let grid = (
                <Grid data={this._gridData} options={this._gridOptions} id="TicketMachinesGrid"
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                    customButtons={customButtons} onClickCustomButton={this._handleClickCustomButton}
                    selectFilter={this.state.selected == null ? null : this.state.selected.Language.LanguageName}
                    gridDetails={{
                        useFeature: true
                    }}
                    useFloatingButtons={true}
                />
            );
            return (grid)
        } else {
            return <></>
        }
    }


    private _handleClickCustomButton = (id: string, dataItem: MachineViewModel) => {
        switch (id) {
            case this._copyFromProject:
                this._loadMachineSearch(DataSource.project);
                break;
            case this._TIDShppingCart:
                this.__TIDopenShppingCart(dataItem.Id)
                break;
            case this._createNew:
                this._createNewMachine();
                break;
        }
    }

    private _createNewMachine = () => {
        var entity = null;
        const sheet = General.Sheet.Manager.createSheetWithUrl(`Machine/New?initAddress=${this.props.entity.Adresse_Key}`)
        sheet.bind(SheetEventType.SavedSuccessfully, (data: { entity }) => {
            entity = data.entity;
        })
        sheet.bind(SheetEventType.Close, () => {
            if (Helper.hasValue(entity) && !Helper.isNullOrEmpty(entity.MaschNr)) {
                this._addMachines([{ maschnr: entity.MaschNr }]);
            }
        })
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: MachineViewModel) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this._loadMachineSearch(DataSource.all);
                break;
            case ToolBarStandardButtonType.DELETE:
                this._removeMachine(dataItem.Id)
                break;

        }
    }

    componentDidMount() {
        this._gridOptions = this.props.context.editMachineTicketsGridOptions;
        this._translations = this.props.context.translations;
        this._problemNr = this.props.entity.ProblemNr;
        this._TIDActive = this.props.context.isTIDActive;
        this._loadGridData();
        this._sheet = General.Sheet.Manager.getTopMostSheet();
    }

    render() {
        const grid = this._createGrid();
        return (
            <>
                {grid}
            </>
        );
    }
}

enum DataSource {
    all,
    project
}

interface MachineViewModel {
    Id: string;
    Name: string;
    Address: string;
    Typ: string;
    MaschMainGroup: string;
    MaschGroup: string;
    MaschNr2: string;
}